import styled from "styled-components";

export const TextReset = styled.span`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`
